var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contributor"},[_c('img',{staticClass:"contributor__avatar",attrs:{"src":require("../assets/avatar-placeholder.svg"),"alt":"","width":"32","height":"32"}}),_vm._v(" "),_c('span',{staticClass:"contributor__name gel-pica-bold"},[_vm._v(_vm._s(_vm.displayName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a855c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BbcContributor.vue
// module id = null
// module chunks = 